import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Patient } from '../models/patient';
import { PatientHistory } from '../models/patient-history';
import { PatientService } from './patient.service';

const updateManualPatientInfoUrl = '/patients/updateManualPatientPrivileged';
const getUpdateHistoryUrl = '/patients/manualPatientUpdates';

@Injectable({
  providedIn: 'root'
})
export class ManualPatientService {
  private _patientInfoUpdated = new Subject<void>();
  patientInfoUpdated = this._patientInfoUpdated.asObservable();

  constructor(
    private http: HttpClient,
    private patientService: PatientService
  ) {}

  updateManualPatientInfo(patient: Patient): Observable<Patient> {
    return this.http.post<Patient>(updateManualPatientInfoUrl, patient).pipe(
      tap(() => {
        // Clear cache to force re-fetch of patient and all related data
        // (eligibility, provider info, etc.) ensuring consistency
        this.patientService.clearCache();

        // Notify patient-header component to refresh (reloads patient + eligibility + provider)
        this.patientService.notifyPatientDetailsUpdated();

        // Notify main header component to refresh (reloads patient name)
        this._patientInfoUpdated.next();
      })
    );
  }

  getUpdateHistory(): Observable<PatientHistory[]> {
    return this.http.get<PatientHistory[]>(getUpdateHistoryUrl);
  }
}
